import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { AtendimentoMedicoListWrapper } from './atendimentos-medico-list/AtendimentoMedicoList'
import { HistoricoListWrapper } from './atendimento-historico/HistoricoList'
import { TeleAtendimento } from './atendimento-video/tele-atendimento'
import { PrescricaoWrapper } from './prescricao/PrescricaoPage'
import { MemedReceita } from './prescricao/MemedReceita'
import { AtendimentoGestaoListWrapper } from './atendimentos-gestao/AtendimentoGestaoList'
import { ParecerInterconsultaPage } from './parecer-interconsulta/ParecerInterconsultaPage'

const atendimentosBreadcrumbs: Array<PageLink> = [
  {
    title: 'Atendimentos',
    path: '/apps/atendimentosMedicos/lista',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AtendimentosMedicosPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='lista'
          element={
            <>
              <PageTitle description={t('pagina.atendimentosMedico.descricao')}>
                Atendimentos
              </PageTitle>
              <AtendimentoMedicoListWrapper />
            </>
          }
        />
        <Route
          path='teleAtendimento'
          element={
            <>
              <PageTitle breadcrumbs={atendimentosBreadcrumbs}>Tele Atendimento</PageTitle>
              <TeleAtendimento chamadaPersistente />
            </>
          }
        />
        <Route
          path='parecer/:atendimentoId'
          element={
            <>
              <PageTitle breadcrumbs={atendimentosBreadcrumbs}>Parecer da interconsulta</PageTitle>
              <ParecerInterconsultaPage />
            </>
          }
        />
        <Route
          path='historicoClinico/:pacienteId'
          element={
            <>
              <PageTitle breadcrumbs={atendimentosBreadcrumbs}>Histórico Clínico</PageTitle>
              <HistoricoListWrapper />
            </>
          }
        />
      </Route>
      <Route
        path='prescricao/lauduz/:atendimentoId'
        element={
          <>
            <PageTitle>Prescrição</PageTitle>
            <PrescricaoWrapper />
          </>
        }
      />
      <Route
        path='prescricao/memed/:atendimentoId'
        element={
          <>
            <PageTitle>Prescrição</PageTitle>
            <MemedReceita />
          </>
        }
      />
      <Route
        path='gestao'
        element={
          <>
            <PageTitle description={t('pagina.gestaoAtendimentos.descricao')}>
              Gestão de Atendimentos
            </PageTitle>
            <AtendimentoGestaoListWrapper />
          </>
        }
      />

      <Route index element={<Navigate to='/apps/atendimentosMedicos/lista' />} />
    </Routes>
  )
}

export default AtendimentosMedicosPage
